import { ActivityEntityName } from '../shared/activity.entity.name';
import { Address } from '../shared/address';
import { Allocation } from './allocation';
import { ContactEntity } from '../contact/contact.options';
import { Entity } from '../entity';
import { Location } from '../shared/location';

export const NewRunId = '00000000-0000-0000-0000-000000000000';

export interface RunLocation extends Location {
    name: string;
    description: string;
    address: Address,
    type?: ActivityEntityName.Company | ActivityEntityName.Employee | ActivityEntityName.Equipment;

    // Route Information
    travelDistance?: number;
    travelDuration?: number;
    travelDistanceString?: string;
    travelDurationString?: string;
}

export interface Run extends Entity {

    date: Date;
    resources: ContactEntity[];
    // equipment: ContactEntity[];
    start: RunLocation;
    finish: RunLocation;
    totalDistance: string;
    totalDuration: string;
    travelDuration: string;
    route: any;
    optimised: boolean;
    needsOptimisation: boolean;

    allocations: Allocation[];
    timezone: string;

    createdAt?: Date;
    updatedAt?: Date;
}

export interface RunTemplateEntity extends Entity {
    resources: ContactEntity[];
    start: RunLocation;
    finish: RunLocation;
}

export interface RunEntity extends RunTemplateEntity {
    timezone: string;
}

export interface RunTemplate extends Entity {
    runs: RunTemplateEntity[];
    createdBy: Entity;
}

export interface RunsheetCopyRunsRequest {
    to: Date;
    runs: Partial<string>[];
    timezone: string;
}

export interface RunsheetMoveRunRequest {
    to: Date;
    runId: string;
}

export interface RunsheetMoveWorkRequest {
    fromRunId: string;
    toRunId: string;
    toNewRun: RunEntity,
    allocations: string[]
}


export interface RunsheetMoveWorkResponse {
    fromRun: Run;
    toRun: Run;
}


export interface RunsheetCopyWorkRequest extends RunsheetMoveWorkRequest {
}

export interface RunsheetCopyWorkResponse extends RunsheetMoveWorkResponse {
}

export interface RunsheetCreateFromTemplateRequest {
    to: Date;
    runs: RunTemplateEntity[];
    timezone: string;
}

export interface RunsheetRunTargetRequest {
    date: Date;
    excludeRuns: string[];
    excludeRunByScheduleWorks: string[];
}

export interface RunsheetAddWorkToRunRequest {
    allocations: Allocation[];
    toRunId: string;
    timezone: string;
    toNewRun: RunEntity;
}

export interface RunsheetAddWorkToRunResponse {
    toRun: Run;
}